// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 60 60" {...rest} unit={unit}>
		<title>Injured</title>
		<g>
			<circle id="Oval" fill="#E8E8E8" cx="30" cy="30" r="30"></circle>
			<polygon id="Path" fill="#D0021B" points="25.0502526 34.9497474 11.6152239 
				34.9497474 11.6152239 25.0502526 25.0502526 25.0502526 25.0502526 
				11.6152239 34.9497474 11.6152239 34.9497474 25.0502526 48.3847761 
				25.0502526 48.3847761 34.9497474 34.9497474 34.9497474 34.9497474 
				48.3847761 25.0502526 48.3847761"></polygon>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Injured.js